export default __webpack_public_path__ + "media/images/new-colored-logo-87deb7a540acda165f91e9b448586403.svg";